import { FreeShippingRequestDto } from '@tiendanube/common';
import { FREE_SHIPPING_ROUTES } from './freeShippingRoutes';
import { FreeShippingFormState } from './types';
import { buildUrl, DISCOUNT_OPTION_ID_QUERY_PARAM } from '../marketingRoutes';

export const payloadDigest = (
  data: FreeShippingFormState,
): FreeShippingRequestDto => {
  const {
    priceMinimum,
    categoriesType,
    categories,
    zonesType,
    zones,
    ...rest
  } = data;

  return {
    ...rest,
    categories: categoriesType === 'some' ? categories : [],
    zones: zonesType === 'some' ? zones : [],
    priceMinimum: Number(priceMinimum),
  };
};

export const buildNewFreeShippingUrl = (discountOptionId?: string) =>
  buildUrl(FREE_SHIPPING_ROUTES.newFreeShipping, {
    [DISCOUNT_OPTION_ID_QUERY_PARAM]: discountOptionId,
  });
